module.exports = __webpack_public_path__ + "img/icon_3_13.89bd41df.png";